import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../lib/withRouter';
import { bindActionCreators } from 'redux';
import StoreState from '../../redux/interfaces/StoreState';
import { LoginContainerProps } from './interfaces/LoginContainerProps';
import { onCheckAuthentication, onLogin } from './thunks/LoginThunks';
import { LoginViewProps } from './views/interfaces/LoginViewProps';
import LoginView from './views/LoginView';
import LoginRedirectView from './views/LoginRedirect';
import * as LoginCreators from '../../redux/creators/LoginCreators';

export class LoginContainer extends React.Component<LoginContainerProps> {

  public componentWillMount() {
    this.props.onCheckAuthentication();
  }

  public componentDidUpdate(prevProps: LoginContainerProps): void {
    if (prevProps.App.authenticationToken === null && this.props.App.authenticationToken != null && this.props.history) {
      this.props.history.push('/dashboard');
    }
  }

  public render(): React.ReactNode {

    if (this.props.App.authenticationLoading ||
      this.props.App.authenticationToken != null) {
      return React.createElement(LoginRedirectView);
    }

    const form = this.props.Login.loginForm;
    const loginViewProps: LoginViewProps = {
      form,
      onFormChange: (e: any, data: any) => {
        this.props.onFormChange(form.id, data.name, data.value ?? '', false);
      },
      onFormSubmit: this.props.onLogin,
    };

    return React.createElement(LoginView, loginViewProps);
  }
}

const mapStateToProps = (state: StoreState) => ({ App: state.App, Login: state.Login });

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  onLogin,
  onCheckAuthentication,
  onFormChange: LoginCreators.FormChange,
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer) as any);


